import React, { useEffect, useState, useRef } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import SignatureCanvas from "react-signature-canvas";
import Webcam from "react-webcam";
import Arrow from './arrowoptum.gif'
import { addPatient, checkFileNumber, checkIdnumbers, checkPassportExists, getClinic, getClinicById, getmedprovider, getNextFileNumber, getNextMpino, getPatient, getPlan, getStream, saveWebcamImage } from "../../service/api";
import { toast } from "react-toastify"

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import classnames from "classnames";

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  Nav,
  NavItem,
  NavLink as RsNavLink,
  TabContent,
  TabPane,
  Modal,
  ModalHeader,
  ModalBody,

} from "reactstrap";


const defaultValue = {
  clinicname: "",
  patientcate: "",
  mpino: "",
  sQuantityUnit: "",
  dossierType: "",
  title: "",
  firstname: "",
  lastname: "",
  dob: "",
  age: "",
  nationality: "South African",
  gender: "",
  idnumber: "",
  passportNumber: "",
  expiryDate: "",
  religion: "",
  citizenship: "",
  language: "",
  race: "",
  mobile: "",
  email: "",
  altNumber: "",
  fund: "no",
  address: "",
  suburb: "",
  city: "",
  acode: "",
  region: "",
  ward: "",
  employed: "",
  kin: "",
  maidname: "",
  mplan: "",
  mfno: "",
  mamount: "",
  mdepcode: "",
  mainmemberdetail: {
    mmtitle: "",
    mmfname: "",
    mmlname: "",
    mmnationality: "",
    mmidnumber: "",
    mmdob: "",
    mmage: "",
    mmgender: "",
    mmreligion: "",
    mmcitizenship: "",
    mmlanguage: "",
    mmrace: "",
    mmmobile: "",
    mmemail: "",
    mmaltNumber: "",
    mmexpiryDate: "",
    mmpassportNumber: "",
  }
}

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { addCountry, getdossierType } from "service/api"
import { jwtDecode } from "jwt-decode";

const Addpatient = ({ onPatientAdded, skipNavigation = false, isModal = false }) => {
  const ALLOWED_DOCUMENT_EXTENSIONS = [".pdf", ".jpg", ".jpeg", ".png", ".doc", ".docx", ".xls", ".xlsx", ".csv"];
  const [dob, setDob] = useState("");
  const [age, setAge] = useState("");
  const [passportError, setPassportError] = useState("");
  const [mmPassportError, setMmPassportError] = useState("");
  const [idnumberError, setidnumberError] = useState("");
  const [mmidnumberError, setmmidnumberError] = useState("");
  const [filenoError, setfilenoError] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [inputValueAlter, setInputAlterValue] = useState("");
  const [mmInputValue, setMmInputValue] = useState("");
  const [mmInputValueAlter, setMmInputValueAlter] = useState("");
  const [formattedValue, setFormattedValue] = useState("");
  const location = useLocation();
  const [formattedValueAlter, setFormattedValueAlter] = useState("");
  const [med_provider, setmed_provider] = useState({ Med_provider: [] })
  const [plan, setPlan] = useState({ plan: [] })
  const [nationality, setNationality] = useState("South African");
  const [mmnationality, setmmNationality] = useState("South African");
  const [sameAsPatient, setSameAsPatient] = useState(false);
  const [showArrow, setShowArrow] = useState(true);
  const [patient, setPatient] = useState(defaultValue);
  const [allcliniclist, setallclinic] = useState([]);
  const [patients, setPatients] = useState([]);
  const [showMedicalFund, setShowMedicalFund] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [patientDocuments, setPatientDocuments] = useState([]);
  const [documentPreviews, setDocumentPreviews] = useState([]);
  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [activePreview, setActivePreview] = useState(null);
  const [customActiveTab, setcustomActiveTab] = useState("1");
  const addressRef = useRef(null);
  const [str, setStr] = useState([])
  const [errors, setErrors] = useState({});


  const navigate = useNavigate();

  const onValueChange = (e) => {
    const { name, value } = e.target;
    if (name == "mmidnumber") {
      // alert()
      if (/^\d*$/.test(value) && value.length <= 13) {
        mmcalculateDOBAndGender(value);
      }
    }
    if ((name === "passportNumber" || name === "mmpassportNumber")) {
      validatePassportNumber(value, name);
    }
    if ((name === "idnumber" || name === "mmidnumber")) {
      validatecheckIdnumbers(value, name);
    }
    if (name === "lastname" && value.length >= 3) {
      generateFileNumber(value);
    }
    if (name === "fileno") {
      validatecheckFileNumber(value, name);
    }

    if (name === "clinicname") {
      const selectedClinic = allcliniclist.find(c => c._id === value);
      const firstFive = selectedClinic?.code?.substring(0, 5) || "";

      setPatient(prev => ({
        ...prev,
        clinicname: value,
        fileno: firstFive // ✅ Auto-fill fileno with first 5 digits
      }));

      generateMPINumber(value);
    }

    // Check if it's a main member field
    if (name.startsWith("mm")) {
      setPatient(prev => ({
        ...prev,
        mainmemberdetail: {
          ...prev.mainmemberdetail,
          [name]: value
        }
      }));
    } else {
      setPatient(prev => ({
        ...prev,
        [name]: value
      }));

      if (name === "clinicname") {
        generateMPINumber(value);
      }

      if (name === "fund") {
        setShowMedicalFund(value === "yes");
      }

      if (name === "idnumber") {
        if (/^\d*$/.test(value) && value.length <= 13) {
          calculateDOBAndGender(value);
        }
      }

    }
  };
  useEffect(() => {
    if (location.state) {
      const mobile = location.state.mobile || "";
      const dob = location.state.dob || "";
      setPatient((prev) => ({
        ...prev,
        title: location.state.title || "",
        firstname: location.state.firstname || "",
        lastname: location.state.lastname || "",
        idnumber: location.state.idnumber || "",
        gender: location.state.gender || "",
        dob,
        email: location.state.email || "",
        mobile,
      }));
      if (mobile) {
        // Strip "27" prefix for display — user only sees the 9 digits
        const displayMobile = mobile.startsWith("27") ? mobile.slice(2) : mobile;
        setInputValue(displayMobile);
        setFormattedValue(mobile);
      }
      if (dob) {
        calculateAge(dob);
      }
      if (location.state.lastname && location.state.lastname.length >= 3) {
        generateFileNumber(location.state.lastname);
      }
    }
    getStreamData();
  }, [location.state]);
  const getAllplan = async () => {
    try {
      const response = await getPlan();
      if (response.data?.plan) {
        setPlan(response.data);
      } else {
        console.error("Unexpected data structure", response.data);
        setPlan({ plan: [] });
      }
    } catch (error) {
      console.error("Error while fetching med getPlan:", error);
      setPlan({ plan: [] });
    }
  };
  const getAllmedprovider = async () => {
    try {
      const response = await getmedprovider();

      if (response.data?.Med_provider) {
        setmed_provider(response.data);  // ✅ Set as-is
      } else {
        console.error("Unexpected data structure", response.data);
        setmed_provider({ Med_provider: [] });
      }
    } catch (error) {
      console.error("Error while fetching med providers:", error);
      setmed_provider({ Med_provider: [] });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation checks — build message-per-field so the summary alert can list them.
    const validationErrors = {};
    if (patient.City === "") validationErrors.City = "City is required";
    if (!patient.title) validationErrors.title = "Title is required";
    if (!patient.firstname) validationErrors.firstname = "First Name is required";
    if (!patient.lastname) validationErrors.lastname = "Last Name is required";
    if (!patient.age) validationErrors.age = "Age is required";
    if (!patient.mobile) validationErrors.mobile = "Mobile Number is required";
    if (!patient.sQuantityUnit) validationErrors.sQuantityUnit = "Classification is required";

    setErrors(validationErrors);

    const hasErrors = Object.keys(validationErrors).length > 0;

    if (hasErrors) {
      toast.error("Please fill out all required fields before saving.");
      return;
    }

    // if (signatureRef.isEmpty()) {
    //   toast.error("Please sign before saving.");
    //   return;
    // }
    setIsSubmitting(true);
    try {
      saveSignature();
      // Combine clinic code + generated fileno
      const clinicCode = allcliniclist
        .find(clinic => clinic._id === patient.clinicname)
        ?.code?.substring(0, 5) || "";

      const finalFileNo = clinicCode + (patient.fileno || "");

      const updatedPatient = {
        ...patient,
        fileno: finalFileNo
      };

      const formData = new FormData();
      formData.append("signature", signatureRef.toDataURL());
      patientDocuments.forEach((file) => {
        formData.append("patient_documents", file);
      });

      Object.keys(updatedPatient).forEach((key) => {
        if (key === "mainmemberdetail" && typeof updatedPatient[key] === "object") {
          formData.append(key, JSON.stringify(updatedPatient[key]));
        } else {
          formData.append(key, updatedPatient[key]);
        }
      });
      const response = await addPatient(formData);
      console.log("Response:", response.data);

      toast.success(
        ({ closeToast }) => (
          <div style={{ fontFamily: "Arial, sans-serif" }}>
            <p style={{ margin: 0, fontWeight: "bold" }}>
              Patient Registered Successfully.
            </p>
            <div
              style={{
                marginTop: "6px",
                background: "#f1f1f1",
                padding: "8px 12px",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <span style={{ fontFamily: "monospace" }}>
                MPI NO: {response.data.mpino}
              </span>
              <button
                onClick={() => {
                  navigator.clipboard.writeText(response.data.mpino);
                  toast.success("MPI NO copied!");
                }}
                style={{
                  marginLeft: "12px",
                  padding: "5px 10px",
                  fontSize: "0.8rem",
                  backgroundColor: "#28a745",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Copy
              </button>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                marginTop: "12px",
              }}
            >
              <button
                onClick={() => {
                  closeToast();
                  navigate(`/Addvisit/${response.data.patientid}`);
                }}
                style={{
                  backgroundColor: "#007bff",
                  color: "#fff",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "4px",
                }}
              >
                Go to Visit
              </button>
              <button
                onClick={closeToast}
                style={{
                  backgroundColor: "#6c757d",
                  color: "#fff",
                  border: "none",
                  padding: "6px 12px",
                  borderRadius: "4px",
                }}
              >
                OK
              </button>
            </div>
          </div>
        ),
        {
          autoClose: false,
          closeOnClick: false,
          draggable: false,
        }
      );

      documentPreviews.forEach((preview) => {
        if (preview?.url) URL.revokeObjectURL(preview.url);
      });
      setPatientDocuments([]);
      setDocumentPreviews([]);


      // Navigate to /Patient after 1.5 seconds
      if (typeof onPatientAdded === "function") {
        onPatientAdded(); // this will close the modal and optionally refresh
      } else if (!skipNavigation) {
        setTimeout(() => {
          navigate("/Patient");
        }, 2500);
      }

      await handleImageUpload();

    } catch (error) {
      if (!skipNavigation) {
        toast.error("Failed to save user. Check console for details.");
        if (error.response) {
          console.error("Response Data:", error.response.data);
          console.error("Response Status:", error.response.status);
        }
      }
    }
    finally {
      setIsSubmitting(false); // ✅ End loading
    }
  };

  const onDateChange = e => {
    const { name, value } = e.target
    if (name === "dob") {
      calculateAge(value)
      setPatient(prevState => ({
        ...prevState,
        dob: value,
      }))
    }
  }

  const getCategoryFromAge = (age) => {
    const n = parseInt(age, 10);
    if (isNaN(n)) return "";
    if (n <= 19) return "Child/Adolescent (0–19 years)";
    if (n <= 59) return "Adult (20–59 years)";
    return "Elder/Senior (60+ years)";
  };

  const calculateAge = dob => {
    const today = new Date()
    const birthDate = new Date(dob)
    let age = today.getFullYear() - birthDate.getFullYear()
    const month = today.getMonth() - birthDate.getMonth()
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    setPatient(prevState => ({
      ...prevState,
      age: age.toString(),
      patientcate: getCategoryFromAge(age),
    }))
  }

  const getStreamData = async () => {
    let response = await getStream()
    setStr(response.data)
  }

  const onmmDateChange = e => {
    const { name, value } = e.target;
    if (name === "mmdob") {
      const mmage = mmcalculateAge(value);
      setPatient(prev => ({
        ...prev,
        mainmemberdetail: {
          ...prev.mainmemberdetail,
          mmdob: value,
          mmage,
        }
      }));
    }
  };


  const mmcalculateAge = dob => {
    const today = new Date()
    const birthDate = new Date(dob)

    let mmage = today.getFullYear() - birthDate.getFullYear()
    const month = today.getMonth() - birthDate.getMonth()
    if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
      // alert(mmage)
      mmage--
    }
    return mmage.toString();
    // setPatient(prevState => ({
    //   ...prevState,
    //   mmage: mmage.toString(),
    // }))
  }
  useEffect(() => {
    const initAutocomplete = () => {
      if (!addressRef.current) return;

      const autocomplete = new window.google.maps.places.Autocomplete(
        addressRef.current,
        {
          types: ["geocode"],
          componentRestrictions: { country: "ZA" }
        }
      );

      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (!place.address_components) return;

        let suburb = "";
        let city = "";
        let areaCode = "";

        place.address_components.forEach(component => {
          const types = component.types;

          if (types.includes("sublocality") || types.includes("sublocality_level_1") || types.includes("neighborhood")) {
            suburb = component.long_name;
          }

          if (types.includes("locality")) {
            city = component.long_name;
          }

          if (types.includes("postal_code")) {
            areaCode = component.long_name;
          }
        });

        setPatient(prev => ({
          ...prev,
          address: place.formatted_address || "",
          suburb,
          city,
          acode: areaCode
        }));
      });
    };

    if (window.google && window.google.maps && window.google.maps.places) {
      initAutocomplete();
    } else {
      const interval = setInterval(() => {
        if (window.google && window.google.maps && window.google.maps.places) {
          clearInterval(interval);
          initAutocomplete();
        }
      }, 200);
      return () => clearInterval(interval);
    }
  }, []);
  const [mobileError, setMobileError] = useState("");
  const [mobileAlterError, setMobileAlterError] = useState("");
  // const onMobileChange = e => {
  //   let value = e.target.value

  //   if (!value.startsWith("27")) {
  //     value = "27" + value
  //   }
  //   setInputValue(value)
  //   let formatted = value.replace(/^27+0*/, "27")
  //   setFormattedValue(formatted)
  //   setPatient({ ...patient, [e.target.name]: formatted })
  // }
  const onMobileChange = e => {
    // Display: show exactly what user types (up to 11 digits, including leading 0)
    // Storage: strip leading 0 then prepend 27 (0812345678 → 27812345678)
    const digits = e.target.value.replace(/\D/g, "").slice(0, 11);
    setInputValue(digits);
    const clean = digits.startsWith("0") ? digits.slice(1) : digits;
    const stored = clean ? "27" + clean : "";
    setFormattedValue(stored);
    setPatient(prev => ({ ...prev, [e.target.name]: stored }));
  };
  // const onMobileChangeAlter = e => {
  //   let value = e.target.value

  //   if (!value.startsWith("27")) {
  //     value = "27" + value
  //   }

  //   setInputAlterValue(value)
  //   let formattedAlter = value.replace(/^27+0*/, "27")
  //   setFormattedValueAlter(formattedAlter)
  //   setPatient({ ...patient, [e.target.name]: formattedAlter })
  // }
  const onMobileChangeAlter = e => {
    // Display: show exactly what user types (up to 11 digits, including leading 0)
    // Storage: strip leading 0 then prepend 27 (0812345678 → 27812345678)
    const digits = e.target.value.replace(/\D/g, "").slice(0, 11);
    setInputAlterValue(digits);
    const clean = digits.startsWith("0") ? digits.slice(1) : digits;
    const stored = clean ? "27" + clean : "";
    setFormattedValueAlter(stored);
    setPatient(prev => ({ ...prev, [e.target.name]: stored }));
  };

  // Main-member mobile handlers use their own display state so they don't overwrite
  // the patient's own mobile fields (which caused the "fill all required fields"
  // false positive when only the main-member mobile was entered).
  const onMmMobileChange = e => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 11);
    setMmInputValue(digits);
    const clean = digits.startsWith("0") ? digits.slice(1) : digits;
    const stored = clean ? "27" + clean : "";
    setPatient(prev => ({ ...prev, [e.target.name]: stored }));
  };

  const onMmMobileChangeAlter = e => {
    const digits = e.target.value.replace(/\D/g, "").slice(0, 11);
    setMmInputValueAlter(digits);
    const clean = digits.startsWith("0") ? digits.slice(1) : digits;
    const stored = clean ? "27" + clean : "";
    setPatient(prev => ({ ...prev, [e.target.name]: stored }));
  };
  const onNationalityChange = e => {
    const val = e.target.value;
    setNationality(val);
    setPatient(prev => ({ ...prev, nationality: val }));
  }
  // const onmmNationalityChange = e => {
  //   setmmNationality(e.target.value)
  //   setPatient({ ...patient, nationality: e.target.value })
  // }

  const onmmNationalityChange = e => {
    const value = e.target.value;
    setmmNationality(value);
    setPatient(prev => ({
      ...prev,
      mainmemberdetail: {
        ...prev.mainmemberdetail,
        mmnationality: value,
      },
    }));
  };


  const handleSameAsPatient = (checked) => {
    setSameAsPatient(checked);
    if (checked) {
      const nat = patient.nationality || "South African";
      setmmNationality(nat);
      setMmInputValue(inputValue);
      setMmInputValueAlter(inputValueAlter);
      setPatient(prev => ({
        ...prev,
        mainmemberdetail: {
          ...prev.mainmemberdetail,
          mmtitle: patient.title || "",
          mmfname: patient.firstname || "",
          mmlname: patient.lastname || "",
          mmnationality: nat,
          mmidnumber: patient.idnumber || "",
          mmpassportNumber: patient.passportNumber || "",
          mmexpiryDate: patient.expiryDate || "",
          mmdob: patient.dob || "",
          mmage: patient.age || "",
          mmgender: patient.gender || "",
          mmreligion: patient.religion || "",
          mmcitizenship: patient.citizenship || "",
          mmlanguage: patient.language || "",
          mmrace: patient.race || "",
          mmmobile: patient.mobile || "",
          mmemail: patient.email || "",
          mmaltNumber: patient.altNumber || "",
        }
      }));
    }
  };

  const cardTopStyle = {
    backgroundColor: "#DC4C64",
    padding: "6px",
    color: "white",
    height: "30px",
  }


  const [imageSrc, setImageSrc] = useState("")
  const [webcamOpen, setWebcamOpen] = useState(false)
  const [clinicID, setClinicID] = useState(null);

  const videoConstraints = {
    width: 400,
    height: 290,
    facingMode: "user",
  }

  const webcamRef = useRef(null)

  const capture = () => {
    const imageSrc = webcamRef.current.getScreenshot()
    setImageSrc(imageSrc)
  }

  const handleImageUpload = async () => {
    if (imageSrc) {
      try {
        await saveWebcamImage(imageSrc); // Call the API to save the image
        console.log("Image saved successfully");
      } catch (error) {
        console.error("Error uploading image:", error);
      }
    } else {
      console.error("No image to upload");
    }
  };

  const [signatureRef, setSignatureRef] = useState(null)

  useEffect(() => {
    return () => {
      documentPreviews.forEach((preview) => {
        if (preview?.url) URL.revokeObjectURL(preview.url);
      });
    };
  }, [documentPreviews]);

  const clearSignature = () => {
    signatureRef.clear()
  }

  const saveSignature = () => {
    const signatureImage = signatureRef.toDataURL()
    // Handle saving the signature image or data
    console.log(signatureImage)
    // Optionally, hide or disable the signature pad after saving
  }
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const decoded = jwtDecode(token);
      setClinicID(decoded?.clinicID || null);
    }
    getallclinic();
    getPatientAll();
    getAllmedprovider();
    getAllplan();
  }, []);


  const getallclinic = async () => {
    try {
      let response;
      if (clinicID) {
        response = await getClinicById(clinicID);
        setallclinic([response.data]);
      } else {
        response = await getClinic();
        setallclinic(response.data);
      }
    } catch (err) {
      console.error("Error fetching clinic(s)", err);
    }
  };



  const getPatientAll = async () => {
    let response = await getPatient();
    setPatients(response.data);
    console.log(response.data);
  }

  // const generateMPINumber = (clinicName) => {
  //   if (clinicName.length < 3) return;
  //   const clinicCode = clinicName.substring(0, 3).toLowerCase();

  //   const clinicPatients = patients.filter(p => p.clinicname === clinicName);
  //   const lastPatient = clinicPatients.length > 0 ? clinicPatients[clinicPatients.length - 1] : null;

  //   let newMPINo;
  //   if (lastPatient) {
  //     const lastMPINo = lastPatient.mpino;
  //     const numericPart = parseInt(lastMPINo.slice(3), 10) + 1;
  //     newMPINo = clinicCode + numericPart.toString().padStart(5, '0');
  //   } else {
  //     newMPINo = clinicCode + '00001';
  //   }

  //   setPatient(prevState => ({ ...prevState, mpino: newMPINo }));
  // };

  // const generateMPINumber = (clinicId) => {
  //   // Find the clinic object from its ID
  //   const selectedClinic = allcliniclist.find(clinic => clinic._id === clinicId);
  //   if (!selectedClinic) return;

  //   // Get the first 3 letters of the clinic's name
  //   const clinicName = selectedClinic.name || '';
  //   const clinicCode = clinicName.substring(0, 3).toUpperCase();

  //   // Filter patients that belong to this clinic
  //   const clinicPatients = patients.filter(p => p.clinicname === clinicId);
  //   const lastPatient = clinicPatients.length > 0 ? clinicPatients[clinicPatients.length - 1] : null;

  //   let newMPINo;
  //   if (lastPatient) {
  //     const lastMPINo = lastPatient.mpino;
  //     const numericPart = parseInt(lastMPINo.slice(3), 10) + 1;
  //     newMPINo = clinicCode + numericPart.toString().padStart(5, '0');
  //   } else {
  //     newMPINo = clinicCode + '00001';
  //   }

  //   setPatient(prevState => ({ ...prevState, mpino: newMPINo }));
  // };

  const generateMPINumber = async (clinicId) => {
    try {
      const response = await getNextMpino(clinicId);
      setPatient(prev => ({
        ...prev,
        mpino: response.data.mpino
      }));
    } catch (error) {
      console.error("Error fetching MPI number:", error);
    }
  };
  const calculateDOBAndGender = (idNumber) => {
    if (idNumber.length === 13) {
      const dobPart = idNumber.substring(0, 6); // Get the first 6 digits
      const year = dobPart.substring(0, 2);
      const month = dobPart.substring(2, 4);
      const day = dobPart.substring(4, 6);
      const currentYear = new Date().getFullYear().toString().substring(2, 4);

      // Determine the full year
      const fullYear = parseInt(year, 10) + (parseInt(year, 10) <= parseInt(currentYear) ? 2000 : 1900);

      // Set the Date of Birth
      const dob = `${fullYear}-${month}-${day}`; // Format YYYY-MM-DD

      // Determine gender based on the next digit
      const genderDigit = idNumber.charAt(6);
      const gender = genderDigit < '5' ? 'Female' : 'Male';
      const title = gender === 'Male' ? 'Mr' : 'Ms';

      setPatient((prev) => ({
        ...prev,
        dob,
        gender,
        title,
        age: calculateAge(dob),
      }));
    }
  };
  const mmcalculateDOBAndGender = (mmidnumber) => {

    if (mmidnumber.length === 13) {
      const dobPart = mmidnumber.substring(0, 6); // Get the first 6 digits
      const year = dobPart.substring(0, 2);
      const month = dobPart.substring(2, 4);
      const day = dobPart.substring(4, 6);
      const currentYear = new Date().getFullYear().toString().substring(2, 4);

      // Determine the full year
      const fullYear = parseInt(year, 10) + (parseInt(year, 10) <= parseInt(currentYear) ? 2000 : 1900);

      // Set the Date of Birth
      const mmdob = `${fullYear}-${month}-${day}`; // Format YYYY-MM-DD

      // Determine gender based on the next digit
      const genderDigit = mmidnumber.charAt(6);
      const mmgender = genderDigit < '5' ? 'Female' : 'Male';
      const mmtitle = mmgender === 'Male' ? 'Mr' : 'Ms';

      setPatient(prev => ({
        ...prev,
        mainmemberdetail: {
          ...prev.mainmemberdetail,
          mmdob,
          mmgender,
          mmtitle,
          mmage: mmcalculateAge(mmdob),
        },
      }));

    }
  };

  const toggleCustom = tab => {
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab);
    }
  };

  const validatePassportNumber = async (value, fieldName) => {
    if (value.length === 8 || value.length === 9) {
      try {
        const clinicIdToUse = clinicID || patient.clinicname;

        const response = await checkPassportExists({
          params: {
            passportNumber: value,
            clinicId: clinicIdToUse, // include clinic ID in request
          },
        });

        if (response.data.exists) {
          if (fieldName === "passportNumber") {
            setPassportError("Passport number already exists");
          } else if (fieldName === "mmpassportNumber") {
            setMmPassportError("Passport number already exists");
          }
        } else {
          fieldName === "passportNumber"
            ? setPassportError("")
            : setMmPassportError("");
        }
      } catch (error) {
        console.error("Error checking passport:", error);
      }
    } else {
      // Clear error if length is less than 8
      fieldName === "passportNumber"
        ? setPassportError("")
        : setMmPassportError("");
    }
  };
  const validatecheckIdnumbers = async (value, fieldName) => {
    if (value.length === 12 || value.length === 13) {
      try {
        const clinicIdToUse = clinicID || patient.clinicname;
        const response = await checkIdnumbers({
          params: {
            idnumber: value,
            clinicId: clinicIdToUse, // include clinic ID in request
          },
        });
        if (response.data.exists) {
          if (fieldName === "idnumber") {
            setidnumberError("idnumber already exists");
          } else if (fieldName === "mmidnumber") {
            setmmidnumberError("idnumber already exists");
          }
        } else {
          fieldName === "idnumber"
            ? setidnumberError("")
            : setmmidnumberError("");
        }
      } catch (error) {
        console.error("Error checking idnumber:", error);
      }
    } else {
      // Clear error if length is less than 8
      fieldName === "idnumber"
        ? setidnumberError("")
        : setmmidnumberError("");
    }
  };

  const validatecheckFileNumber = async (value, fieldName) => {
    if (value.length === 4 || value.length === 5) {
      try {
        const clinicIdToUse = clinicID || patient.clinicname;
        const response = await checkFileNumber({
          params: {
            fileno: value,
            clinicId: clinicIdToUse,
          },
        });
        if (response.data.exists) {
          if (fieldName === "fileno") {
            setfilenoError("fileno already exists");
          }
        } else {
          fieldName === "fileno"
          setfilenoError("")
        }
      } catch (error) {
        console.error("Error checking fileno:", error);
      }
    } else {
      // Clear error if length is less than 8
      fieldName === "fileno"
      setfilenoError("")
    }
  };

  const generateFileNumber = async (lastname) => {
    try {
      const response = await getNextFileNumber(lastname);

      setPatient(prev => ({
        ...prev,
        fileno: response.data.fileno
      }));

    } catch (error) {
      console.error("Error generating fileno:", error);
    }
  };
  const today = new Date().toISOString().split('T')[0];

  useEffect(() => {
    const clinicToUse = clinicID || location.state?.clinicname;
    if (clinicToUse && patients.length > 0 && allcliniclist.length > 0) {
      // Auto-select clinic and generate MPI No.
      setPatient(prev => ({ ...prev, clinicname: clinicToUse }));
      generateMPINumber(clinicToUse);
    }
  }, [clinicID, patients, allcliniclist]); // Runs only when both are ready


  const maleRef = useRef(null);
  const femaleRef = useRef(null);
  const nonbinaryRef = useRef(null);

  useEffect(() => {
    if (patient.gender === "Male") maleRef.current.checked = true;
    else if (patient.gender === "Female") femaleRef.current.checked = true;
    else if (patient.gender === "Nonbinary") nonbinaryRef.current.checked = true;
  }, [patient.gender]);

  const mmmaleRef = useRef(null);
  const mmfemaleRef = useRef(null);
  const mmnonbinaryRef = useRef(null);

  useEffect(() => {
    if (patient.mainmemberdetail.mmgender === "Male") mmmaleRef.current.checked = true;
    else if (patient.mainmemberdetail.mmgender === "Female") mmfemaleRef.current.checked = true;
    else if (patient.mainmemberdetail.mmgender === "Nonbinary") mmnonbinaryRef.current.checked = true;
  }, [patient.mainmemberdetail.mmgender]);

  const handleFundChange = (value) => {
    setPatient(prev => ({ ...prev, fund: value }));
    setShowMedicalFund(value === "yes");

    if (value !== "yes" && customActiveTab !== "1") {
      setcustomActiveTab("1");
    }
  };

  const getFileExtension = (fileName = "") => {
    const index = fileName.lastIndexOf(".");
    return index >= 0 ? fileName.slice(index).toLowerCase() : "";
  };

  const handlePatientDocumentsChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    if (selectedFiles.length === 0) {
      setPatientDocuments([]);
      setDocumentPreviews([]);
      return;
    }

    const invalidFiles = selectedFiles.filter(file => !ALLOWED_DOCUMENT_EXTENSIONS.includes(getFileExtension(file.name)));
    if (invalidFiles.length > 0) {
      toast.error("Only PDF, image, Word, and Excel files are allowed.");
      e.target.value = "";
      return;
    }

    const previews = selectedFiles.map(file => ({
      name: file.name,
      type: file.type,
      url: URL.createObjectURL(file),
      isPreviewable: file.type.startsWith("image/") || file.type === "application/pdf",
    }));

    setPatientDocuments(selectedFiles);
    setDocumentPreviews(previews);
  };

  const removePatientDocument = (indexToRemove) => {
    setPatientDocuments(prev => prev.filter((_, index) => index !== indexToRemove));
    setDocumentPreviews(prev => {
      const previewToRemove = prev[indexToRemove];
      if (previewToRemove?.url) URL.revokeObjectURL(previewToRemove.url);
      return prev.filter((_, index) => index !== indexToRemove);
    });
  };

  const openDocumentPreview = (doc) => {
    if (!doc?.isPreviewable) return;
    setActivePreview(doc);
    setPreviewModalOpen(true);
  };

  document.title = "ADD Patient | Form"
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {!isModal && (
            <div className="d-flex justify-content-between align-items-center mb-2">
              {/* <CardTitle className="mb-4">ADD Patient</CardTitle> */}
              <h4 className="page-title">ADD Patient</h4>
              <Link to="/Patient" className="btn btn-danger">
                View Patients
              </Link>
            </div>
          )}
          <Row>
            <Card>
              <CardBody>
                {/* <Form onSubmit={handleSubmit}> */}
                <Form>
                  <Row>
                    {!isModal && (
                      <Col md={12} className="mb-3">
                        <div style={{ display: "inline-flex", alignItems: "center", gap: "20px", padding: "8px 16px", backgroundColor: "#fff5f7", borderRadius: "6px", border: "1px solid #f5c6cb" }}>
                          <span style={{ fontWeight: "600", color: "#DC4C64", fontSize: "13px", marginRight: "4px" }}>Medical Fund :</span>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <div
                              className="form-check form-radio-danger"
                              style={{ marginRight: "10px" }}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name="fund"
                                id="yes"
                                value="yes"
                                checked={patient.fund === "yes"}
                                onClick={() => handleFundChange("yes")}
                                onChange={() => { }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="yes"
                                style={{ color: "#212529", fontWeight: "500" }}
                              >
                                Yes
                              </label>
                            </div>
                            <div
                              className="form-check form-radio-danger"
                              style={{ marginRight: "10px" }}
                            >
                              <input
                                className="form-check-input"
                                type="radio"
                                name="fund"
                                id="no"
                                value="no"
                                checked={patient.fund === "no"}
                                onClick={() => handleFundChange("no")}
                                onChange={() => { }}
                              />
                              <label
                                className="form-check-label"
                                htmlFor="no"
                                style={{ color: "#212529", fontWeight: "500" }}
                              >
                                No
                              </label>
                            </div>
                          </div>
                        </div>
                      </Col>
                    )}
                    <Nav
                      tabs
                      className="nav-tabs-custom nav-justified mb-0"
                      style={{
                        borderBottom: "2px solid #DC4C64",
                        background: "#f8f9fa",
                        borderRadius: "6px 6px 0 0",
                        padding: "6px 6px 0",
                        gap: "4px",
                      }}
                    >
                      <NavItem>
                        <RsNavLink
                          style={{ cursor: "pointer" }}
                          className={classnames({
                            active: customActiveTab === "1",
                          })}
                          onClick={() => { toggleCustom("1"); }}
                        >
                          <span className="d-block d-sm-none">
                            <i className="fas fa-home"></i>
                          </span>
                          <span className="d-none d-sm-block">
                            <i className="fas fa-user-circle me-2"></i>Patient Details
                          </span>
                        </RsNavLink>
                      </NavItem>
                      {showMedicalFund && (
                        <NavItem>
                          <RsNavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: customActiveTab === "2",
                            })}
                            onClick={() => { toggleCustom("2"); }}
                          >
                            <span className="d-block d-sm-none">
                              <i className="far fa-user"></i>
                            </span>
                            <span className="d-none d-sm-block">
                              <i className="fas fa-file-medical me-2"></i>Medical Aid Details
                            </span>
                          </RsNavLink>
                        </NavItem>
                      )}
                      {showMedicalFund && (
                        <NavItem>
                          <RsNavLink
                            style={{ cursor: "pointer" }}
                            className={classnames({
                              active: customActiveTab === "3",
                            })}
                            onClick={() => { toggleCustom("3"); }}
                          >
                            <span className="d-block d-sm-none">
                              <i className="far fa-envelope"></i>
                            </span>
                            <span className="d-none d-sm-block">
                              <i className="fas fa-users me-2"></i>Main Member Details
                            </span>
                          </RsNavLink>
                        </NavItem>
                      )}
                    </Nav>
                  </Row>
                  <TabContent
                    activeTab={customActiveTab}
                    className="p-3"
                    style={{
                      border: "1px solid #dee2e6",
                      borderTop: "none",
                      borderRadius: "0 0 6px 6px",
                      backgroundColor: "#ffffff",
                    }}
                  >
                    <TabPane tabId="2">
                      {/* {showMedicalFund && ( */}
                      <Row>
                        <Col md={12}>
                          <div style={cardTopStyle} className="mb-4 d-flex align-items-center">
                            <CardTitle className="mb-0">
                              <i className="fas fa-file-medical me-2"></i>Medical Aid Information
                            </CardTitle>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-country-Input"> Medical Aid Name</Label>
                            <select name="maidname" className="form-control" onChange={onValueChange}>
                              <option defaultValue>Select Medical Aid</option>
                              {Array.isArray(med_provider.Med_provider) &&
                                med_provider.Med_provider.map((item, index) => (
                                  <option key={index} value={item.med_provider}>
                                    {item.med_provider}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-country-Input">Plan</Label>
                            <select name="mplan" className="form-control" onChange={onValueChange}>
                              <option defaultValue>Select  Plan</option>
                              {Array.isArray(plan.plan) &&
                                plan.plan.map((item, index) => (
                                  <option key={index} value={item.plan}>
                                    {item.plan}
                                  </option>
                                ))}
                            </select>
                          </div>
                        </Col>
                        {/* <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              Plan
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Plan"
                              name="mplan"
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col> */}
                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              Medical Fund Number
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Medical Fund Number"
                              name="mfno"
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              Amount
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Amount"
                              name="mamount"
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              Dependant Code
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Dependant Code"
                              name="mdepcode"
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>
                      </Row>
                      {/* )} */}
                    </TabPane>
                    <TabPane tabId="3">
                      <Row>
                        <Col md={12}>
                          <div style={{ ...cardTopStyle, justifyContent: "space-between" }} className="mb-4 d-flex align-items-center">
                            <CardTitle className="mb-0">
                              <i className="fas fa-users me-2"></i>Main Member Details
                            </CardTitle>
                            <label style={{ display: "flex", alignItems: "center", gap: "6px", cursor: "pointer", fontSize: "12px", fontWeight: "500", color: "#fff", margin: 0 }}>
                              <input
                                type="checkbox"
                                onClick={e => handleSameAsPatient(e.target.checked)}
                                style={{ width: "14px", height: "14px", cursor: "pointer", accentColor: "#fff" }}
                              />
                              Same as Patient Details
                            </label>
                          </div>
                        </Col>
                        <Col md={1}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-country-Input">
                              Title
                            </Label>
                            <select
                              name="mmtitle"
                              className="form-control"
                              onChange={e => onValueChange(e)}
                            >
                              <option defaultValue>Select</option>
                              <option >Mr</option>
                              <option>Ms</option>
                              <option >Mrs</option>
                              <option >Dr</option>
                              <option>Prof</option>
                              {/* <option>3</option>
                          <option>4</option>
                          <option>5</option> */}
                            </select>
                          </div>
                        </Col>
                        <Col md={2}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              First Name
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="First Name"
                              name="mmfname"
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>
                        <Col md={2}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              Last Name
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Last Name"
                              name="mmlname"
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          {/* <h5 className="font-size-14 mb-2">Nationality</h5> */}
                          <Label htmlFor="formrow-squantity-Input">
                            Nationality
                          </Label>
                          <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                            {["South African", "Non-South African", "Non-Documented"].map((val) => (
                              <button
                                key={val}
                                type="button"
                                onClick={() => { setmmNationality(val); setPatient(prev => ({ ...prev, mainmemberdetail: { ...prev.mainmemberdetail, mmnationality: val } })); }}
                                style={{
                                  padding: "2px 9px", borderRadius: "20px", cursor: "pointer",
                                  border: `1.5px solid ${mmnationality === val ? "#DC4C64" : "#ced4da"}`,
                                  background: mmnationality === val ? "#fff0f3" : "#fff",
                                  fontSize: "11px", fontWeight: mmnationality === val ? "600" : "500",
                                  color: mmnationality === val ? "#DC4C64" : "#333",
                                  transition: "all 0.15s", userSelect: "none",
                                }}
                              >
                                {val}
                              </button>
                            ))}
                          </div>
                        </Col>
                        {mmnationality === "South African" && (
                          <Col md={3}>
                            <div className="mb-3">
                              <Label htmlFor="formrow-squantity-Input">
                                ID Number
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                name="mmidnumber"
                                placeholder="ID Number"
                                maxLength="13"
                                onKeyPress={(e) => {
                                  if (e.which < 48 || e.which > 57) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value) && value.length <= 13) {
                                    onValueChange(e);
                                  }
                                }}
                              />
                              {mmidnumberError && <small className="text-danger">{mmidnumberError}</small>}
                            </div>
                          </Col>
                        )}
                        {mmnationality === "Non-South African" && (
                          <>
                            <Col md={4}>
                              <div className="mb-3">
                                <Label htmlFor="formrow-mmpassport-Input">Main Member Passport Number</Label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  name="mmpassportNumber"
                                  placeholder="Passport Number"
                                  maxLength={9}
                                  onChange={onValueChange}
                                />
                                {mmPassportError && <small className="text-danger">{mmPassportError}</small>}
                              </div>
                            </Col>
                            <Col md={2}>
                              <div className="mb-3">
                                <Label htmlFor="formrow-squantity-Input">Expiry Date</Label>
                                <Input
                                  type="date"
                                  className="form-control"
                                  name="mmexpiryDate"
                                  placeholder="Expiry Date"
                                  min={today} // ✅ This disables past dates
                                  onChange={e => onValueChange(e)}
                                />
                              </div>
                            </Col>
                          </>
                        )}

                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              Date Of Birth
                            </Label>
                            <Input
                              type="date"
                              className="form-control"
                              placeholder="Date Of Birth"
                              name="mmdob"
                              value={patient.mainmemberdetail.mmdob}
                              onChange={onmmDateChange}
                            />
                          </div>
                        </Col>
                        <Col md={2}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              Age
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Age"
                              name="mmage"
                              value={patient?.mainmemberdetail?.mmage}
                            />
                          </div>
                        </Col>
                        <Col md={4} >
                          <h5 className="font-size-14 mb-2">Gender</h5>
                          <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                            {[
                              { id: "mmgenderMale", value: "Male", ref: mmmaleRef, label: "Male" },
                              { id: "mmgenderFemale", value: "Female", ref: mmfemaleRef, label: "Female" },
                              { id: "mmgenderNonbinary", value: "nonbinary", ref: mmnonbinaryRef, label: "Nonbinary" },
                            ].map(({ id, value, ref, label }) => (
                              <label key={id} htmlFor={id} style={{
                                display: "inline-flex", alignItems: "center", gap: "6px",
                                padding: "2px 9px", borderRadius: "20px", cursor: "pointer",
                                border: `1.5px solid ${patient.mainmemberdetail.mmgender === value ? "#DC4C64" : "#ced4da"}`,
                                background: patient.mainmemberdetail.mmgender === value ? "#fff0f3" : "#fff",
                                fontSize: "11px", fontWeight: "500", color: "#333",
                                transition: "all 0.15s", userSelect: "none",
                              }}>
                                <input
                                  type="radio" id={id} name="mmgender" value={value}
                                  ref={ref}
                                  onChange={e => onValueChange(e)}
                                  style={{ accentColor: "#DC4C64", width: "13px", height: "13px", cursor: "pointer" }}
                                />
                                {label}
                              </label>
                            ))}
                          </div>
                        </Col>

                        <Col lg={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-dosage">Religion</Label>
                            <select
                              name="mmreligion"
                              className="form-control"
                              onChange={e => onValueChange(e)}
                            >
                              <option defaultValue>Select</option>
                              <option>Animism</option>
                              <option>Buddhism</option>
                              <option>Christianity</option>
                              <option>Hinduism</option>
                              <option>Islam</option>
                              <option>Judaism</option>
                              <option>Sikhism</option>
                              <option>Traditional African</option>
                              <option>Unknown</option>
                            </select>
                          </div>
                        </Col>
                        <Col lg={2}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-dosage">Citizenship</Label>
                            <select
                              name="mmcitizenship"
                              className="form-control"
                              value={patient.mmcitizenship || "South Africa"}
                              onChange={e => onValueChange(e)}
                            >
                              <option defaultValue>Select</option>
                              <option>Angola</option>
                              <option>Botswana</option>
                              <option>Comoros</option>
                              <option>Democratic Republic of Congo(DRC)</option>
                              <option>Lesotho</option>
                              <option>Madagascar</option>
                              <option>Malawi</option>
                              <option>Mauritius</option>
                              <option>Mozambique</option>
                              <option>Nambia</option>
                              <option>Seychelles</option>
                              <option>South Africa</option>
                              <option>Swziland</option>
                              <option>United Republic of Tanzania</option>
                              <option>Zambia</option>
                              <option>Zimbabwe</option>
                              <option>Other</option>
                            </select>
                          </div>
                        </Col>
                        <Col lg={2}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-dosage">Language</Label>
                            <select
                              name="mmlanguage"
                              className="form-control"
                              onChange={e => onValueChange(e)}
                            >
                              <option defaultValue>Select</option>
                              {/* <option value="">Select</option> */}
                              <option>Afrikaans</option>
                              <option>English</option>
                              <option>Isindebele</option>
                              <option>Isixhosa</option>
                              <option>Isizulu</option>
                              <option>Other</option>
                              <option>Sepedi</option>
                              <option>Sesotho</option>
                              <option>Setswana</option>
                              <option>Siswati</option>
                              <option>Tshivenda</option>
                              <option>Unknown</option>
                              <option>Xitsonga</option>
                            </select>
                          </div>
                        </Col>
                        <Col lg={2}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-dosage">Race</Label>
                            <select
                              name="mmrace"
                              className="form-control"
                              onChange={e => onValueChange(e)}
                            >
                              <option defaultValue>Select</option>
                              <option>Black</option>
                              <option>Coloured</option>
                              <option>Indian</option>
                              <option>Other</option>
                              <option>White</option>
                            </select>
                          </div>
                        </Col>

                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              Mobile Number
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="digits e.g. 0123456789"
                              maxLength={11}
                              name="mmmobile"
                              value={mmInputValue}
                              onKeyPress={(e) => {
                                if (e.which < 48 || e.which > 57) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={e => onMmMobileChange(e)}
                            />
                            {/* {errors.mobile && <span className="text-danger">*Please fill out this field</span>} */}

                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">Email</Label>
                            <Input
                              type="emal"
                              className="form-control"
                              name="mmemail"
                              placeholder="Email"
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              Alternative Number
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="digits e.g. 0123456789"
                              name="mmaltNumber"
                              maxLength={11}
                              value={mmInputValueAlter}
                              onKeyPress={(e) => {
                                if (e.which < 48 || e.which > 57) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={e => onMmMobileChangeAlter(e)}
                            />
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="1">
                      <Row>
                        <Col md={12}>
                          <div style={cardTopStyle} className="mb-4 d-flex align-items-center">
                            <CardTitle className="mb-0">
                              <i className="fas fa-id-card me-2"></i>Registration &amp; Classification
                            </CardTitle>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-country-Input">
                              Practice Name
                            </Label>
                            <select
                              name="clinicname"
                              className="form-control"
                              onChange={(e) => onValueChange(e)}
                              value={patient.clinicname}
                              disabled={!!clinicID} // disable if clinicID exists
                            >
                              {!clinicID && <option value="">Choose...</option>}
                              {allcliniclist.map((clinic) => (
                                <option key={clinic._id} value={clinic._id}>
                                  {clinic.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-country-Input">
                              Patient Category
                            </Label>
                            <select
                              name="patientcate"
                              className="form-control"
                              value={patient.patientcate || ""}
                              onChange={e => onValueChange(e)}
                            >
                              <option defaultValue>Select</option>
                              <option>Child/Adolescent (0–19 years)</option>
                              <option>Adult (20–59 years)</option>
                              <option>Elder/Senior (60+ years)</option>
                            </select>
                          </div>
                        </Col>

                        <Col md={2}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">MPI No.</Label>
                            <Input type="text" className="form-control" name="mpino" value={patient.mpino} readOnly />
                          </div>
                        </Col>

                        <Col md={2}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-fileno-Input">File No.</Label>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <Input
                                type="text"
                                value={
                                  allcliniclist.find(clinic => clinic._id === patient.clinicname)?.code?.substring(0, 5) || ""
                                }
                                readOnly
                                style={{
                                  width: "65px",
                                  marginRight: "-1px",
                                  backgroundColor: "#f8f9fa",
                                  border: "1px solid #ced4da",
                                  textAlign: "center"
                                }}
                              />
                              <Input
                                type="text"
                                className="form-control"
                                name="fileno"
                                maxLength="5"
                                onKeyPress={(e) => {
                                  if (e.which < 48 || e.which > 57) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value) && value.length <= 13) {
                                    onValueChange(e);
                                  }
                                }}
                                placeholder="File No."
                                value={patient.fileno}
                              />
                            </div>
                            {filenoError && <small className="text-danger">{filenoError}</small>}

                          </div>
                        </Col>

                        <Col lg={2}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-login">Classification</Label>
                            <select
                              name="sQuantityUnit"
                              className="form-control"
                              onChange={e => onValueChange(e)}
                            >
                              {str.length > 0 ? (
                                <>
                                  <option defaultValue>Select</option>
                                  {str.map(s => (
                                    <option key={s._id} value={s._id}>
                                      {s.name}
                                    </option>
                                  ))}
                                </>
                              ) : (
                                <option disabled>No Classification available</option>
                              )}
                            </select>
                            {errors.sQuantityUnit && <span className="text-danger">*Please fill out this field</span>}
                          </div>
                        </Col>
                        <Col md={12}>
                          <div style={{ ...cardTopStyle, marginTop: "16px", marginBottom: "16px" }} className="d-flex align-items-center">
                            <CardTitle className="mb-0">
                              <i className="fas fa-user me-2"></i>Personal Information
                            </CardTitle>
                          </div>
                        </Col>
                        <Col lg={1}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-dosage">Title<span style={{ color: "red", fontWeight: "bolder" }}>*</span></Label>
                            <select
                              name="title"
                              className="form-control"
                              value={patient.title}
                              onChange={e => onValueChange(e)}
                            >
                              <option value="">Select</option>
                              <option value="Mr">Mr</option>
                              <option value="Ms">Ms</option>
                              <option value="Mrs">Mrs</option>
                              <option value="Dr">Dr</option>
                              <option value="Prof">Prof</option>
                            </select>
                            {errors.title && <span className="text-danger">*required</span>}
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              First Name<span style={{ color: "red", fontWeight: "bolder" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="firstname"
                              placeholder="Fist Name"
                              value={patient.firstname}
                              onKeyPress={(e) => {
                                const charCode = e.which || e.keyCode;
                                if (!/^[a-zA-Z\s]*$/.test(String.fromCharCode(charCode))) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                if (/^[a-zA-Z\s]*$/.test(value)) {
                                  onValueChange({ ...e, target: { ...e.target, name: e.target.name, value } });
                                }
                              }}
                            />
                            {errors.firstname && <span className="text-danger">*Please fill out this field</span>}

                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              Last Name<span style={{ color: "red", fontWeight: "bolder" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="lastname"
                              placeholder="Last Name"
                              value={patient.lastname}
                              onKeyPress={(e) => {
                                const charCode = e.which || e.keyCode;
                                if (!/^[a-zA-Z\s]*$/.test(String.fromCharCode(charCode))) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={(e) => {
                                const value = e.target.value.toUpperCase();
                                if (/^[a-zA-Z\s]*$/.test(value)) {
                                  onValueChange({ ...e, target: { ...e.target, name: e.target.name, value } });
                                }
                              }}
                            />
                            {errors.lastname && <span className="text-danger">*Please fill out this field</span>}

                          </div>
                        </Col>
                        <Col md={5}>
                          {/* <h5 className="font-size-14 mb-2">Nationality</h5> */}
                          <Label htmlFor="formrow-squantity-Input">
                            Nationality
                          </Label>
                          <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                            {["South African", "Non-South African", "Non-Documented"].map((val) => (
                              <button
                                key={val}
                                type="button"
                                onClick={() => { setNationality(val); setPatient(prev => ({ ...prev, nationality: val })); }}
                                style={{
                                  padding: "2px 9px", borderRadius: "20px", cursor: "pointer",
                                  border: `1.5px solid ${nationality === val ? "#DC4C64" : "#ced4da"}`,
                                  background: nationality === val ? "#fff0f3" : "#fff",
                                  fontSize: "11px", fontWeight: nationality === val ? "600" : "500",
                                  color: nationality === val ? "#DC4C64" : "#333",
                                  transition: "all 0.15s", userSelect: "none",
                                }}
                              >
                                {val}
                              </button>
                            ))}
                          </div>
                        </Col>
                        {nationality === "South African" && (
                          <Col md={2}>
                            <div className="mb-3">
                              <Label htmlFor="formrow-squantity-Input">
                                ID Number
                              </Label>
                              <Input
                                type="text"
                                className="form-control"
                                name="idnumber"
                                placeholder="ID Number"
                                maxLength="13"
                                value={patient.idnumber || ""}
                                onKeyPress={(e) => {
                                  if (e.which < 48 || e.which > 57) {
                                    e.preventDefault();
                                  }
                                }}
                                onChange={(e) => {
                                  const value = e.target.value;
                                  if (/^\d*$/.test(value) && value.length <= 13) {
                                    onValueChange(e);
                                  }
                                }}
                              />
                              {idnumberError && <small className="text-danger">{idnumberError}</small>}

                            </div>
                          </Col>
                        )}
                        <Col md={2}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              Date Of Birth
                            </Label>
                            <Input
                              type="date"
                              className="form-control"
                              name="dob"
                              value={patient.dob}
                              onChange={onDateChange}
                            />
                          </div>
                        </Col>
                        <Col md={1}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">Age<span style={{ color: "red", fontWeight: "bolder" }}>*</span></Label>
                            <Input
                              type="text"
                              className="form-control"
                              name="age"
                              value={patient.age}
                              readOnly
                              onChange={e => onValueChange(e)}
                            />
                            {errors.age && <span className="text-danger">*Please fill out this field</span>}
                          </div>
                        </Col>
                        <Col md={4}>
                          {/* <h5 className="font-size-14 mb-2">Gender</h5> */}
                          <Label htmlFor="formrow-squantity-Input">
                            Gender
                          </Label>
                          <div style={{ display: "flex", alignItems: "center", gap: "6px", flexWrap: "wrap" }}>
                            {[
                              { id: "Male", value: "male", ref: maleRef, label: "Male" },
                              { id: "Female", value: "Female", ref: femaleRef, label: "Female" },
                              { id: "nonbinary", value: "nonbinary", ref: nonbinaryRef, label: "Nonbinary" },
                            ].map(({ id, value, ref, label }) => (
                              <label key={id} htmlFor={id} style={{
                                display: "inline-flex", alignItems: "center", gap: "6px",
                                padding: "2px 9px", borderRadius: "20px", cursor: "pointer",
                                border: `1.5px solid ${patient.gender === value ? "#DC4C64" : "#ced4da"}`,
                                background: patient.gender === value ? "#fff0f3" : "#fff",
                                fontSize: "11px", fontWeight: "500", color: "#333",
                                transition: "all 0.15s", userSelect: "none",
                              }}>
                                <input
                                  type="radio" id={id} name="gender" value={value}
                                  ref={ref}
                                  onChange={e => onValueChange(e)}
                                  style={{ accentColor: "#DC4C64", width: "13px", height: "13px", cursor: "pointer" }}
                                />
                                {label}
                              </label>
                            ))}
                          </div>
                        </Col>

                        {nationality === "Non-South African" && (
                          <>
                            <Col md={4}>
                              <div className="mb-3">
                                <Label htmlFor="formrow-passport-Input">Passport Number</Label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  name="passportNumber"
                                  placeholder="Passport Number"
                                  maxLength={9}
                                  onChange={onValueChange}
                                />
                                {passportError && <small className="text-danger">{passportError}</small>}
                              </div>
                            </Col>

                            <Col md={2}>
                              <div className="mb-3">
                                <Label htmlFor="formrow-squantity-Input">
                                  Expiry Date
                                </Label>
                                <Input
                                  type="date"
                                  className="form-control"
                                  name="expiryDate"
                                  placeholder="ID Number"
                                  min={today}
                                  onChange={e => onValueChange(e)}
                                />
                              </div>
                            </Col>
                          </>
                        )}
                        {!isModal && (
                          <>
                            <Col lg={3}>
                              <div className="mb-3">
                                <Label htmlFor="formrow-dosage">Religion</Label>
                                <select
                                  name="religion"
                                  className="form-control"
                                  onChange={e => onValueChange(e)}
                                >
                                  <option defaultValue>Select</option>
                                  <option>Animism</option>
                                  <option>Buddhism</option>
                                  <option>Christianity</option>
                                  <option>Hinduism</option>
                                  <option>Islam</option>
                                  <option>Judaism</option>
                                  <option>Sikhism</option>
                                  <option>Traditional African</option>
                                  <option>Unknown</option>
                                </select>
                              </div>
                            </Col>
                            <Col lg={2}>
                              <div className="mb-3">
                                <Label htmlFor="formrow-dosage">Citizenship</Label>
                                <select
                                  name="citizenship"
                                  className="form-control"
                                  value={patient.citizenship || "South Africa"}
                                  onChange={e => onValueChange(e)}
                                >
                                  <option defaultValue>Select</option>
                                  <option>Angola</option>
                                  <option>Botswana</option>
                                  <option>Comoros</option>
                                  <option>Democratic Republic of Congo(DRC)</option>
                                  <option>Lesotho</option>
                                  <option>Madagascar</option>
                                  <option>Malawi</option>
                                  <option>Mauritius</option>
                                  <option>Mozambique</option>
                                  <option>Nambia</option>
                                  <option>Seychelles</option>
                                  <option>South Africa</option>
                                  <option>Swziland</option>
                                  <option>United Republic of Tanzania</option>
                                  <option>Zambia</option>
                                  <option>Zimbabwe</option>
                                  <option>Other</option>
                                </select>
                              </div>
                            </Col>
                            <Col lg={2}>
                              <div className="mb-3">
                                <Label htmlFor="formrow-dosage">Language</Label>
                                <select
                                  name="language"
                                  className="form-control"
                                  onChange={e => onValueChange(e)}
                                >
                                  <option defaultValue>Select</option>
                                  <option>Afrikaans</option>
                                  <option>English</option>
                                  <option>Isindebele</option>
                                  <option>Isixhosa</option>
                                  <option>Isizulu</option>
                                  <option>Other</option>
                                  <option>Sepedi</option>
                                  <option>Sesotho</option>
                                  <option>Setswana</option>
                                  <option>Siswati</option>
                                  <option>Tshivenda</option>
                                  <option>Unknown</option>
                                  <option>Xitsonga</option>
                                </select>
                              </div>
                            </Col>
                            <Col lg={2}>
                              <div className="mb-3">
                                <Label htmlFor="formrow-dosage">Race</Label>
                                <select
                                  name="race"
                                  className="form-control"
                                  onChange={e => onValueChange(e)}
                                >
                                  <option defaultValue>Select</option>
                                  <option>Black</option>
                                  <option>Coloured</option>
                                  <option>Indian</option>
                                  <option>Other</option>
                                  <option>White</option>
                                </select>
                              </div>
                            </Col>
                          </>
                        )}
                        <Col md={12}>
                          <div style={{ ...cardTopStyle, marginTop: "16px", marginBottom: "16px" }} className="d-flex align-items-center">
                            <CardTitle className="mb-0">
                              <i className="fas fa-phone me-2"></i>Contact Information
                            </CardTitle>
                          </div>
                        </Col>
                        <Col md={3}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-squantity-Input">
                              Mobile Number<span style={{ color: "red", fontWeight: "bolder" }}>*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="digits e.g. 0123456789
"
                              maxLength={11}
                              name="mobile"
                              value={inputValue}
                              onKeyPress={(e) => {
                                if (e.which < 48 || e.which > 57) {
                                  e.preventDefault();
                                }
                              }}
                              onChange={e => onMobileChange(e)}
                            />
                            {errors.mobile && <span className="text-danger">*Please fill out this field</span>}

                          </div>
                        </Col>
                        {!isModal && (
                          <>
                            <Col md={3}>
                              <div className="mb-3">
                                <Label htmlFor="formrow-squantity-Input">Email</Label>
                                <Input
                                  type="email"
                                  className="form-control"
                                  name="email"
                                  placeholder="Email"
                                  value={patient.email || ""}
                                  onChange={e => onValueChange(e)}
                                />
                              </div>
                            </Col>
                            <Col md={3}>
                              <div className="mb-3">
                                <Label htmlFor="formrow-squantity-Input">
                                  Alternative Number
                                </Label>
                                <Input
                                  type="text"
                                  className="form-control"
                                  placeholder="digits e.g. 0123456789"
                                  name="altNumber"
                                  maxLength={11}
                                  value={inputValueAlter}
                                  onKeyPress={(e) => {
                                    if (e.which < 48 || e.which > 57) {
                                      e.preventDefault();
                                    }
                                  }}
                                  onChange={e => onMobileChangeAlter(e)}
                                />
                              </div>
                            </Col>
                          </>
                        )}
                      </Row>
                      <Card>
                        <CardBody>
                          {!isModal && (
                            <>
                              <Col md={12}>
                                <div style={{ ...cardTopStyle, marginTop: "16px", marginBottom: "16px" }} className="d-flex align-items-center">
                                  <CardTitle className="mb-0">
                                    <i className="fas fa-home me-2"></i>Address
                                  </CardTitle>
                                </div>
                              </Col>
                            </>
                          )}
                          <Form>
                            <Row>
                              <Col md={6}>
                                <div className="mb-3">
                                  <Label htmlFor="formrow-squantity-Input">
                                    Address
                                  </Label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="address"
                                    ref={addressRef}
                                    value={patient.address || ""}
                                    onChange={e => onValueChange(e)}
                                    autoComplete="off"
                                  />
                                </div>
                              </Col>
                              {!isModal && (
                                <>
                                  <Col md={2}>
                                    <div className="mb-3">
                                      <Label htmlFor="formrow-squantity-Input">
                                        Suburb
                                      </Label>
                                      <Input
                                        type="text"
                                        className="form-control"
                                        name="suburb"
                                        value={patient.suburb || ""}
                                        onChange={e => onValueChange(e)}
                                      />
                                    </div>
                                  </Col>
                                  <Col md={2}>
                                    <div className="mb-3">
                                      <Label htmlFor="formrow-squantity-Input">
                                        City
                                        {/* <span style={{ color: "red", fontWeight: "bolder" }}>*</span> */}
                                      </Label>
                                      <Input
                                        type="text"
                                        className="form-control"
                                        name="city"
                                        value={patient.city || ""}
                                        onChange={e => onValueChange(e)}
                                      />
                                      {errors.City && <span className="text-danger">*Please fill out this field</span>}

                                    </div>
                                  </Col>
                                  <Col md={2}>
                                    <div className="mb-3">
                                      <Label htmlFor="formrow-squantity-Input">
                                        Area Code
                                      </Label>
                                      <Input
                                        type="text"
                                        className="form-control"
                                        name="acode"
                                        maxLength={5}
                                        value={patient.acode || ""}
                                        // onChange={e => onValueChange(e)}
                                        onKeyPress={(e) => {
                                          if (e.which < 48 || e.which > 57) {
                                            e.preventDefault();
                                          }
                                        }}
                                        onChange={(e) => {
                                          const value = e.target.value;
                                          if (/^\d*$/.test(value) && value.length <= 13) {
                                            onValueChange(e);
                                          }
                                        }}
                                      />
                                    </div>
                                  </Col>
                                </>
                              )}
                              {/* <Col md={4}>
                                <div className="mb-3">
                                  <Label htmlFor="formrow-country-Input">
                                    Region
                                  </Label>
                                  <select
                                    name="region"
                                    className="form-control"
                                    onChange={e => onValueChange(e)}
                                  >
                                    <option defaultValue>Select</option>
                                    <option>Thswane</option>
                                  
                                  </select>
                                </div>
                              </Col>
                              <Col md={4}>
                                <div className="mb-3">
                                  <Label htmlFor="formrow-country-Input">
                                    Ward
                                  </Label>
                                  <select
                                    name="ward"
                                    className="form-control"
                                    onChange={e => onValueChange(e)}
                                  >
                                    <option defaultValue>Select</option>
                                    <option>Ward-1</option>
                                    <option>Ward-2</option>
                                   
                                  </select>
                                </div>
                              </Col> */}
                              {/* <Col md={3}>
                                <h5 className="font-size-14 mb-3">
                                  Is the patient employed ?
                                </h5>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    className="form-check form-radio-danger"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="employed"
                                      id="employed"
                                      value="yes"
                                      onChange={e => onValueChange(e)}
                                      defaultChecked
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="exampleRadios1"
                                    >
                                      Yes
                                    </label>
                                  </div>
                                  <div
                                    className="form-check form-radio-danger"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="employed"
                                      id="emloyed"
                                      value="No"
                                      onChange={e => onValueChange(e)}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="exampleRadios2"
                                    >
                                      No
                                    </label>
                                  </div>
                                </div>
                              </Col>
                              <Col md={3}>
                                <h5 className="font-size-14 mb-3">
                                  Does the patient have next of kin ?
                                </h5>
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <div
                                    className="form-check form-radio-danger"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="kin"
                                      id="kin"
                                      value="yes"
                                      onChange={e => onValueChange(e)}
                                      defaultChecked
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="exampleRadios1"
                                    >
                                      Yes
                                    </label>
                                  </div>
                                  <div
                                    className="form-check form-radio-danger"
                                    style={{ marginRight: "10px" }}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name="kin"
                                      id="kin"
                                      value="No"
                                      onChange={e => onValueChange(e)}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor="exampleRadios2"
                                    >
                                      No
                                    </label>
                                  </div>
                                </div>
                              </Col> */}
                              {/* <b /> */}
                              {/* <br /> */}
                              <Col md={12}>
                                <div className="mb-3">
                                  <Row className="g-3">
                                    {!isModal && (
                                      <Col md={4}>
                                        <div style={{ border: "1px solid #dee2e6", borderRadius: 10, padding: 12, minHeight: 210 }}>
                                          <Label htmlFor="live-image-capture">
                                            <b>Live Image Capture</b>
                                          </Label>
                                          {webcamOpen ? (
                                            <div>
                                              <Webcam
                                                audio={false}
                                                ref={webcamRef}
                                                screenshotFormat="image/jpeg"
                                                videoConstraints={videoConstraints}
                                                style={{ width: "100%", borderRadius: 8, border: "1px solid #ccc" }}
                                              />
                                              <div className="d-flex gap-2 mt-2">
                                                <Button type="button" onClick={() => capture(webcamRef)} color="primary" size="sm">
                                                  Capture
                                                </Button>
                                                <Button type="button" onClick={() => setWebcamOpen(false)} color="secondary" size="sm">
                                                  Close
                                                </Button>
                                              </div>
                                            </div>
                                          ) : (
                                            <div>
                                              <Button
                                                type="button"
                                                onClick={() => {
                                                  setWebcamOpen(true)
                                                  setShowArrow(false)
                                                }}
                                                color="primary"
                                                size="sm"
                                              >
                                                Open Webcam
                                              </Button>
                                              {showArrow && (
                                                <img
                                                  src={Arrow}
                                                  alt="arrow"
                                                  style={{ width: "32px", height: "32px", marginLeft: "10px" }}
                                                />
                                              )}
                                            </div>
                                          )}
                                          {imageSrc && (
                                            <div className="mt-3 d-flex align-items-center gap-2">
                                              <img
                                                src={imageSrc}
                                                alt="Captured"
                                                style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 8, border: "1px solid #ccc" }}
                                              />
                                              <span style={{ fontSize: 12, color: "#495057" }}>Image captured</span>
                                            </div>
                                          )}
                                        </div>
                                      </Col>
                                    )}

                                    <Col md={4}>
                                      <div style={{ border: "1px solid #dee2e6", borderRadius: 10, padding: 12, minHeight: 210 }}>
                                        <Label htmlFor="digital-signature">
                                          <b>Digital Signature</b>
                                        </Label>
                                        <div className="signature-container">
                                          <SignatureCanvas
                                            penColor="black"
                                            canvasProps={{
                                              width: 220,
                                              height: 110,
                                              className: "signature-canvas",
                                              style: { border: "2px solid #ccc", borderRadius: 8, width: "100%" },
                                            }}
                                            ref={ref => setSignatureRef(ref)}
                                          />
                                        </div>
                                        <div className="mt-2 d-flex gap-2 flex-wrap">
                                          <Button type="button" onClick={clearSignature} color="secondary" size="sm">
                                            Clear
                                          </Button>
                                          <Button type="button" onClick={saveSignature} color="primary" size="sm">
                                            Sign
                                          </Button>
                                        </div>
                                      </div>
                                    </Col>

                                    <Col md={4}>
                                      <div style={{ border: "1px solid #dee2e6", borderRadius: 10, padding: 12, minHeight: 210 }}>
                                        <Label htmlFor="patient-documents">
                                          <b>Patient Documents</b>
                                        </Label>
                                        <Input
                                          id="patient-documents"
                                          type="file"
                                          multiple
                                          accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.csv"
                                          onChange={handlePatientDocumentsChange}
                                        />
                                        <div style={{ fontSize: 11, color: "#6c757d", marginTop: 6 }}>
                                          PDF, image, Word, Excel, CSV only
                                        </div>
                                        {documentPreviews.length > 0 && (
                                          <div className="mt-3" style={{ display: "grid", gap: 8 }}>
                                            {documentPreviews.map((doc, index) => (
                                              <div
                                                key={`${doc.name}-${index}`}
                                                style={{
                                                  border: "1px solid #e9ecef",
                                                  borderRadius: 8,
                                                  padding: "6px 8px",
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "space-between",
                                                  gap: 8,
                                                }}
                                              >
                                                <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
                                                  <div
                                                    style={{
                                                      width: 28,
                                                      height: 28,
                                                      borderRadius: 6,
                                                      background: "#f1f3f5",
                                                      display: "flex",
                                                      alignItems: "center",
                                                      justifyContent: "center",
                                                      fontSize: 14,
                                                    }}
                                                  >
                                                    {doc.type === "application/pdf" ? "PDF" : doc.type.startsWith("image/") ? "IMG" : "DOC"}
                                                  </div>
                                                  <div style={{ fontSize: 12, fontWeight: 600, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: 140 }}>
                                                    {doc.name}
                                                  </div>
                                                </div>
                                                <div className="d-flex align-items-center gap-1">
                                                  {doc.isPreviewable && (
                                                    <Button type="button" color="light" size="sm" onClick={() => openDocumentPreview(doc)}>
                                                      View
                                                    </Button>
                                                  )}
                                                  <Button type="button" color="danger" size="sm" onClick={() => removePatientDocument(index)}>
                                                    X
                                                  </Button>
                                                </div>
                                              </div>
                                            ))}
                                          </div>
                                        )}
                                      </div>
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                            </Row>
                          </Form>
                        </CardBody>
                      </Card>
                    </TabPane>
                  </TabContent>
                </Form>
                {Object.values(errors).some(Boolean) && (() => {
                  const errorsByTab = {
                    "1": {
                      label: "Patient Details",
                      items: [
                        errors.sQuantityUnit,
                        errors.title,
                        errors.firstname,
                        errors.lastname,
                        errors.age,
                        errors.mobile,
                        errors.City,
                      ].filter(Boolean),
                    },
                    // Add fields here if Medical Aid Details (tab "2") or
                    // Main Member Details (tab "3") ever become required.
                  };
                  return (
                    <div className="alert alert-danger mt-3">
                      <p className="mb-2"><b>Please fill the required data:</b></p>
                      {Object.entries(errorsByTab).map(([tabId, { label, items }]) =>
                        items.length > 0 && (
                          <div key={tabId} className="mb-2">
                            <div className="mb-1">
                              In <a
                                href="#"
                                onClick={(e) => { e.preventDefault(); toggleCustom(tabId); }}
                                style={{ color: "#842029", fontWeight: 600, textDecoration: "underline" }}
                              >{label}</a> tab:
                            </div>
                            <ul className="mb-0">
                              {items.map((msg, i) => <li key={i}>{msg}</li>)}
                            </ul>
                          </div>
                        )
                      )}
                    </div>
                  );
                })()}
                <div
                  className="d-flex justify-content-end align-items-center mt-3 pt-3"
                  style={{ borderTop: "1px solid #dee2e6" }}
                >
                  <button
                    className="btn btn-primary px-4"
                    onClick={handleSubmit}
                    disabled={
                      isSubmitting ||
                      !!mmPassportError ||
                      !!passportError ||
                      !!mmidnumberError ||
                      !!idnumberError
                    }
                  >
                    {isSubmitting ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Saving...
                      </>
                    ) : (
                      <><i className="fas fa-save me-2"></i>Save Patient</>
                    )}
                  </button>
                </div>
              </CardBody>

              <Modal isOpen={previewModalOpen} toggle={() => setPreviewModalOpen(false)} size="lg" centered>
                <ModalHeader toggle={() => setPreviewModalOpen(false)}>
                  {activePreview?.name || "Document Preview"}
                </ModalHeader>
                <ModalBody>
                  {activePreview?.isPreviewable ? (
                    activePreview.type === "application/pdf" ? (
                      <iframe
                        src={activePreview.url}
                        title={activePreview.name}
                        style={{ width: "100%", height: "70vh", border: "1px solid #ccc", borderRadius: 8 }}
                      />
                    ) : (
                      <img
                        src={activePreview.url}
                        alt={activePreview.name}
                        style={{ width: "100%", maxHeight: "70vh", objectFit: "contain", borderRadius: 8 }}
                      />
                    )
                  ) : (
                    <div style={{ fontSize: 13, color: "#6c757d" }}>
                      Preview is not available for this file type.
                    </div>
                  )}
                </ModalBody>
              </Modal>

              {/* <div className="text-end">
                <button
                  className="btn btn-primary w-md mx-2"
                  onClick={handleSubmit}
                  disabled={!!mmPassportError || !!passportError || !!mmidnumberError || !!idnumberError}
                >
                  Save
                </button>
              </div> */}


            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment >
  )
}

export default Addpatient
